import React, { Component, useState } from "react"
import { get, truncate } from "lodash"
import { Dropdown, Modal, Switch, Tooltip, Menu, Button, message, Tag } from "antd"
import threePoints from "../../images/three-points.svg"
import threePointsGray from "../../images/three-points-gray.svg"
import { ThreePointsIcon } from "../../icons/svg/iconThreePoints"

class SwitchRender extends Component {
  state = { isLoadingQuestion: false }

  render() {
    return (
      <Switch
        loading={this.state.isLoadingQuestion}
        disabled={this.props.disabled}
        checked={this.props.checked}
        onChange={(e) => {
          this.setState({ isLoadingQuestion: true })
          const params = {
            idQuestion: this.props.item.id_question_has_dimension,
            params: { enabled: e ? 1 : 0 },
          }

          setTimeout(() => {
            this.setState({ isLoadingQuestion: false })
          }, 2000)
          this.props.updateQuestionDimensionWatcher(params)
        }}
      />
    )
  }
}

const DimensionBoxMultipleChoice = (props) => {
  const { listQuestionMultipleChoice, updateQuestionDimensionWatcher } = props

  return (
    <div className="dimension-box">
      <div className="dimension-box-header">
        <div className="dimension-box-division">
          <div className="dimension-box-division-left">
            {get(listQuestionMultipleChoice.meta, "icon_url", "") && (
              <img src={get(listQuestionMultipleChoice.meta, "icon_url", "")} />
            )}
            <div className="dimension-box-division-titleBox">
              <span className="dimension-box-division-titleDefault">
                {get(listQuestionMultipleChoice.meta, "title", "")}
              </span>
              <span className="dimension-box-division-subTitleDefault">
                Preguntas para seleccionar una o varias opciones de una lista de
                respuestas.
              </span>
            </div>
          </div>
        </div>
      </div>

      <ul className="multipleChoice-questions">
        {get(listQuestionMultipleChoice, "data", []).map((question, index) => {
          return (
            <li key={index}>
              <div className="questions-li">
                <span className="questions-li-title-multiple">
                  {question.name}
                  {question.required && (<span className='required'>*</span>)}
                  {!question.required && <Tag color="default" className="tagQuestion">Opcional</Tag>}
                </span>
                <div className="questions-li-actions">
                  <SwitchRender
                    disabled={!!props.measures.length}
                    checked={question.enabled}
                    item={question}
                    updateQuestionDimensionWatcher={
                      updateQuestionDimensionWatcher
                    }
                  />
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item
                          key={1}
                          onClick={() => {
                            props.getQuestionTypesWatcher(question.id_survey)
                            props.getQuestionWatcher(question.id_question)
                            props.toggleDrawer("questionsDrawer", true)
                          }}>
                          Editar
                        </Menu.Item>
                        <Menu.Item
                          key={2}
                          onClick={() => {
                            props.toggleDrawer("questionDelete", question)
                            props.openModalDeleteQuestion()
                          }}
                          style={{ color: "#E37879" }}>
                          Eliminar
                        </Menu.Item>
                      </Menu>
                    }
                    placement="bottomRight"
                    overlayStyle={{
                      width: 132,
                      height: 60,
                      textAlign: "left",
                      alignItems: "center",
                      offset: 2,
                    }}>
                    <Button
                      type="link"
                      className="QuestionDrawer__button--edit"
                      icon={
                        <ThreePointsIcon
                          style={{
                            color: question.enabled ? "#378FEE" : "#C4C4C4",
                          }}
                        />
                      }
                    />
                  </Dropdown>
                </div>
              </div>
              <ul className="multiplechoices-ul">
                {question.answer_options.map((answer, index) => {
                  return <li key={index}>{answer}</li>
                })}
              </ul>
              {question.question_segments !== undefined && (
                <div className="segments">
                  {question.question_segments.map((d, di) => (
                    <span className="span-segments"> <b>- {d.segment}:</b> {d.name}</span>
                  ))}
                </div>)
              }
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default DimensionBoxMultipleChoice
